import React from 'react'
import { useTranslation } from 'react-i18next'
import { camelCase } from 'lodash'

import { FeatureList, Table } from '../../../../components/PriceTable'
import { SubscriptionColumn } from './SubscriptionColumn'
import { BILLING_PERIOD } from '../../constants'

export const SubscriptionTable = ({
    products,
    productActions,
    userSubscriptions,
    userSubscription,
    isMobile,
    priceType,
}) => {
    const { t } = useTranslation()

    const reduceTotalMsg = tariff => {
        const price = products[BILLING_PERIOD.annual].filter(({ name }) => name === tariff)[0].price

        return `$ ${price} ${t('_pages._billing_and_payments.annualy')}.`
    }

    const reduceAnnualYouSaveMsg = tariff => {
        const annualPrice = products[BILLING_PERIOD.annual].filter(({ name }) => name === tariff)[0].price
        const monthPrice = products[BILLING_PERIOD.month].filter(({ name }) => name === tariff)[0].price

        const save = Math.round(monthPrice * 12 - annualPrice)

        return `${t('_pages._billing_and_payments.you_save')} $${save}`
    }

    return (
        <Table className="subscriptions__table">
            {isMobile ? null : (
                <FeatureList
                    list={Object.fromEntries(
                        products[priceType][0].featureProducts.map(item => [
                            camelCase(item.name),
                            { name: item.name, description: item.under },
                        ]),
                    )}
                    style={{
                        width: '298px',
                        height: `${products[priceType][0].featureProducts.length * 68}px`,
                    }}
                />
            )}
            {products[priceType].map(description => {
                return (
                    <SubscriptionColumn
                        key={description.name}
                        productAction={productActions[description.name]}
                        description={description}
                        userSubscriptions={userSubscriptions}
                        userSubscription={userSubscription}
                        reduceTotalMsg={reduceTotalMsg}
                        reduceAnnualYouSaveMsg={reduceAnnualYouSaveMsg}
                        isMobile={isMobile}
                    />
                )
            })}
        </Table>
    )
}
